<script setup lang="ts">
const props = defineProps({
  href: {
    type: String,
    default: '',
    required: false,
  },
  image: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  width: {
    type: [Number, String],
    default: 192, // 12rem * 16px = 192px (max-w-[12em])
  },
  height: {
    type: [Number, String],
    default: 48, // h-12 = 48px (3rem)
  },
});
</script>

<template>
  <a
    v-if="props.href"
    :href="props.href"
    rel="noopener"
    target="_blank"
  >
    <img
      :alt="props.title"
      :class="$style.image"
      :height="props.height"
      :src="props.image"
      :title="props.title"
      :width="props.width"
    />
  </a>
  <span v-else>
    <img
      :alt="props.title"
      :class="$style.image"
      :height="props.height"
      :src="props.image"
      :title="props.title"
      :width="props.width"
    />
  </span>
</template>

<style module lang="scss">
.image {
  @apply h-8 w-auto max-w-[12em] lg:h-12;
}
</style>
